import { timeGet, appDauStat } from "../api";
import { DateTime } from "luxon";
import { getOrCreateUserIdentity } from "../system/userId";

function hasVisitedToday(storedDateISO, serverDate) {
  if (!storedDateISO) return false;
  const stored = DateTime.fromISO(storedDateISO, { zone: "America/New_York" });
  return serverDate.startOf("day") <= stored.startOf("day");
}

export async function identityCheckDauLog() {
  try {
    const identity = await getOrCreateUserIdentity(); //  Load or reuse identity first
    if (!identity) throw new Error("Missing user identity");

    const serverTimeISO = await timeGet();
    if (!serverTimeISO) throw new Error("Server time unavailable");

    const nowET = DateTime.fromISO(serverTimeISO, { zone: "America/New_York" });
    const todayET = nowET.toISODate();

    const storedDate = localStorage.getItem("lastVisitET");

    if (!hasVisitedToday(storedDate, nowET)) {
      await appDauStat();
      localStorage.setItem("lastVisitET", todayET);
    //   console.debug("DAU stat logged successfully.");
    } else {
    //   console.debug("DAU stat already sent today.");
    }
  } catch (err) {
    console.error("dauLog error:", err);
  }
}
